export default __webpack_public_path__ + "static/media/confirm.45bb0e76.png";